"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addErrorToXray = exports.showDoggyPageClientSide = void 0;
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
const config_1 = __importDefault(require("next/config"));
const isomorphic_1 = require("../../isomorphic");
const showDoggyPageClientSide = () => __awaiter(void 0, void 0, void 0, function* () {
    const { publicRuntimeConfig } = (0, config_1.default)();
    const amazonUrl = publicRuntimeConfig.amazonUrl;
    const errorUrl = `${amazonUrl !== null && amazonUrl !== void 0 ? amazonUrl : window.location.origin}/errors/`;
    try {
        const doggyPageHtml = yield (0, isomorphic_unfetch_1.default)(errorUrl).then((response) => response.text());
        document.write(doggyPageHtml);
    }
    catch (error) {
        isomorphic_1.LOGGER.error('Failed to write error page content');
        document.location.href = `/errors/`;
    }
});
exports.showDoggyPageClientSide = showDoggyPageClientSide;
const addErrorToXray = (segment, error) => {
    var _a;
    segment === null || segment === void 0 ? void 0 : segment.addAnnotation('errorType', error === null || error === void 0 ? void 0 : error.name);
    segment === null || segment === void 0 ? void 0 : segment.addMetadata('errorMessage', error === null || error === void 0 ? void 0 : error.message);
    if (((_a = error === null || error === void 0 ? void 0 : error.statusCode) === null || _a === void 0 ? void 0 : _a.toString().charAt(0)) === '5') {
        segment === null || segment === void 0 ? void 0 : segment.addFaultFlag();
    }
    else {
        segment === null || segment === void 0 ? void 0 : segment.addErrorFlag();
    }
};
exports.addErrorToXray = addErrorToXray;
